<template>
  <v-card>
    <v-card-title primary-title class="justify-center">
      <div>
        <div class="display-1 font-weight-medium blue--text">
          <v-icon large>help</v-icon>
          Sign Up
        </div>
      </div>
    </v-card-title>
    <v-card-text>
      <v-stepper v-model="step" vertical non-linear>
        <v-stepper-step editable step="1">
          Click on "Sign Up" item in the menu
        </v-stepper-step>

        <v-stepper-content step="1">
          <v-card class="mb-5">
            <img src="~assets/images/help_signup_1.png">
          </v-card>
          <v-btn color="primary" @click="step = 2">Continue</v-btn>
        </v-stepper-content>

        <v-stepper-step editable step="2">Click on the red button</v-stepper-step>

        <v-stepper-content step="2">
          <v-card class="mb-5">
            <img src="~assets/images/help_signup_2.png">
          </v-card>
          <v-btn color="primary" @click="step = 3">Continue</v-btn>
        </v-stepper-content>

        <v-stepper-step editable step="3">
          Type and confirm a password
          <small>Please remember this password as it will be the only way to decrypt your key file.</small>
        </v-stepper-step>

        <v-stepper-content step="3">
          <v-card class="mb-5">
            <img src="~assets/images/help_signup_3.png">
          </v-card>
          <v-btn color="primary" @click="step = 4">Continue</v-btn>
        </v-stepper-content>

        <v-stepper-step editable step="4">
          Download the Key File
          <small>Click on the button to download your key file. Please keep it in a safe place as it will be the only way to access your account.</small>
        </v-stepper-step>

        <v-stepper-content step="4">
          <v-card class="mb-5">
            <img src="~assets/images/help_signup_4.png">
          </v-card>
          <v-btn color="primary" @click="step = 5">Continue</v-btn>
        </v-stepper-content>

        <v-stepper-step editable step="5">
          Request access
          <small>Inform your account ID to a system administrator so they can grant you access.</small>
        </v-stepper-step>

        <v-stepper-content step="5">
          <v-card class="mb-5">
            <img src="~assets/images/help_signup_5.png">
          </v-card>
          <v-btn color="primary" @click="step = 1">Back to start</v-btn>
          <v-btn flat @click="openPage('help')">Back to help</v-btn>
        </v-stepper-content>

      </v-stepper>
    </v-card-text>
  </v-card>
</template>

<style>
  .cursor:hover{
    cursor: pointer;
  }
</style>

<script>
export default {
  props: ['localUserType'],
  data () {
    return {
      localUserType: this.localUserType,
      step: 1
    }
  },
  methods: {
    openPage(name) {
      this.$emit("openPage", name);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/controllers/Help-Signup.vue